import { get } from '..';

const GetUnreadNotificationsCount: () => Promise<{ count: number }> = () => get('button/v2/notifications/unread-count');

export default GetUnreadNotificationsCount;
